import React, { useState } from 'react';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const toISO = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/**
 * Month-grid view of tickets by due date -- no calendar library, just a
 * plain 6x7 grid built from scratch (this project's boards are small
 * enough that a hand-rolled grid is simpler than pulling in a dependency).
 * Tickets with no due_date simply don't appear here (they still show up
 * in the regular board/list view).
 */
const CalendarView = ({ tickets, onOpen }) => {
  const [cursor, setCursor] = useState(new Date());

  const monthStart = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
  const monthEnd = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0);

  const gridStart = new Date(monthStart);
  gridStart.setDate(gridStart.getDate() - gridStart.getDay());
  const gridEnd = new Date(monthEnd);
  gridEnd.setDate(gridEnd.getDate() + (6 - gridEnd.getDay()));

  const days = [];
  for (const d = new Date(gridStart); d <= gridEnd; d.setDate(d.getDate() + 1)) {
    days.push(new Date(d));
  }

  const byDate = {};
  tickets.forEach((t) => {
    if (!t.due_date) return;
    (byDate[t.due_date] = byDate[t.due_date] || []).push(t);
  });

  const todayISO = toISO(new Date());
  const monthLabel = cursor.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });

  return (
    <div className="calendar-view">
      <div className="calendar-nav">
        <button
          type="button"
          className="btn-secondary"
          aria-label="Previous month"
          onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1))}
        >
          &larr;
        </button>
        <span className="calendar-month-label">{monthLabel}</span>
        <button
          type="button"
          className="btn-secondary"
          aria-label="Next month"
          onClick={() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1))}
        >
          &rarr;
        </button>
        <button type="button" className="btn-secondary" onClick={() => setCursor(new Date())}>Today</button>
      </div>

      <div className="calendar-grid">
        {WEEKDAYS.map((d) => (
          <div key={d} className="calendar-weekday">{d}</div>
        ))}
        {days.map((day) => {
          const iso = toISO(day);
          const inMonth = day.getMonth() === cursor.getMonth();
          const dayTickets = byDate[iso] || [];
          const visible = dayTickets.slice(0, 3);
          const overflow = dayTickets.length - visible.length;
          return (
            <div
              key={iso}
              className={`calendar-cell ${inMonth ? '' : 'calendar-cell-outside'} ${iso === todayISO ? 'calendar-cell-today' : ''}`}
            >
              <div className="calendar-cell-date">{day.getDate()}</div>
              <div className="calendar-cell-tickets">
                {visible.map((t) => (
                  <button
                    key={t.id}
                    type="button"
                    className={`calendar-ticket-chip priority-${t.priority}`}
                    onClick={() => onOpen(t.id)}
                    title={`${t.key} · ${t.title}`}
                  >
                    {t.title}
                  </button>
                ))}
                {overflow > 0 && <div className="calendar-more">+{overflow} more</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarView;
